function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 0.75C5.83337 0.75 2.27504 3.34167 0.833374 7C2.27504 10.6583 5.83337 13.25 10 13.25C14.1667 13.25 17.725 10.6583 19.1667 7C17.725 3.34167 14.1667 0.75 10 0.75ZM10 11.1667C7.70004 11.1667 5.83337 9.3 5.83337 7C5.83337 4.7 7.70004 2.83333 10 2.83333C12.3 2.83333 14.1667 4.7 14.1667 7C14.1667 9.3 12.3 11.1667 10 11.1667ZM10 4.5C8.61671 4.5 7.50004 5.61667 7.50004 7C7.50004 8.38333 8.61671 9.5 10 9.5C11.3834 9.5 12.5 8.38333 12.5 7C12.5 5.61667 11.3834 4.5 10 4.5Z",
  fill: "white"
});

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c8e057c6.svg";
export { ForwardRef as ReactComponent };